import type { RouteRecordRaw } from 'vue-router';

import { lazyPage, SeoRobots, type SeoDescriptor } from '@/shared/lib';
import { RouterPages, RouterPaths } from '@/shared/router';

const chatPage = lazyPage(() => import('@/pages/chat'), 'ChatPage');
const chatMeta = {
  seo: {
    title: { key: 'seo.chat.title' },
    description: { key: 'seo.chat.description' },
    robots: SeoRobots.NOINDEX_NOFOLLOW,
  } satisfies SeoDescriptor,
};

const chatRoutes: RouteRecordRaw[] = [
  {
    name: RouterPages.CHAT,
    path: RouterPaths.CHAT,
    component: chatPage,
    meta: chatMeta,
  },
  {
    name: RouterPages.CHAT_USER,
    path: RouterPaths.CHAT_USER,
    component: chatPage,
    meta: chatMeta,
  },
  {
    name: RouterPages.CHAT_GROUP,
    path: RouterPaths.CHAT_GROUP,
    component: chatPage,
    meta: chatMeta,
  },
] as const;

export { chatRoutes };
